import MainStack from "./MainStack";
import { ChatProvider } from "../../../store/ChatStore";


export const MainRootStack = () => {

  return (
    <ChatProvider>
      <MainStack />
    </ChatProvider>
  );
};
